import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidateInputService {

  constructor() { }

  public validateNumberInput(event: Event, allowedCharacters: RegExp): boolean {
    var keyboardEvent = event as KeyboardEvent;
    var character = keyboardEvent.key;
    if (!(character?.match(allowedCharacters) || keyboardEvent.ctrlKey || keyboardEvent.metaKey)) {
      event.preventDefault();
      return false;
    }
    return true;
  }
}
